import { StyleSheet } from 'react-native';

export const createStyles = (theme: 'light' | 'dark' = 'light') => {
  const colors = {
    light: {
      background: '#FFFFFF',
      inputBackground: '#F5F5F5',
      text: '#333333',
      placeholder: '#999999',
      icon: '#999999',
      iconActive: '#333333',
      border: '#E8E8E8',
      searchButton: '#FF2442',
      searchButtonText: '#FFFFFF',
      clear: '#CCCCCC',
    },
    dark: {
      background: '#1A1A1A',
      inputBackground: '#2A2A2A',
      text: '#FFFFFF',
      placeholder: '#666666',
      icon: '#666666',
      iconActive: '#FFFFFF',
      border: '#3A3A3A',
      searchButton: '#FF2442',
      searchButtonText: '#FFFFFF',
      clear: '#555555',
    },
  };

  const c = colors[theme];

  return StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: c.background,
      paddingHorizontal: 12,
      paddingVertical: 8,
    },
    leftExtra: {
      marginRight: 8,
    },
    inputContainer: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: c.inputBackground,
      borderRadius: 20,
      paddingHorizontal: 12,
      height: 36,
    },
    inputContainerSquare: {
      borderRadius: 8,
    },
    inputContainerFocused: {
      borderWidth: 1,
      borderColor: c.searchButton,
    },
    leftIcon: {
      marginRight: 8,
    },
    input: {
      flex: 1,
      fontSize: 14,
      color: c.text,
      padding: 0,
      height: '100%',
    },
    inputDisabled: {
      color: c.placeholder,
    },
    rightIconsContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      marginLeft: 8,
    },
    iconButton: {
      padding: 4,
      marginLeft: 4,
    },
    iconDivider: {
      width: 1,
      height: 16,
      backgroundColor: c.border,
      marginHorizontal: 8,
    },
    clearButton: {
      padding: 4,
    },
    rightExtra: {
      marginLeft: 8,
    },
    searchButton: {
      paddingHorizontal: 16,
      paddingVertical: 8,
      backgroundColor: c.searchButton,
      borderRadius: 18,
      marginLeft: 8,
    },
    searchButtonText: {
      fontSize: 14,
      color: c.searchButtonText,
      fontWeight: '500',
    },
    // 图标样式
    iconDefault: {
      color: c.icon,
    },
    iconActive: {
      color: c.iconActive,
    },
    // 禁用遮罩
    disabledOverlay: {
      ...StyleSheet.absoluteFillObject,
      backgroundColor: 'transparent',
    },
  });
};

export default createStyles;
